import ENV from "config/Env";
import { backendQueryKey, localQueryKey } from "hooks";

import type { DMSWarning, DMS_CAPABILITIES, DMS_WARNING_SERVERITIES, DMS_WARNING_SOURCES } from "models";
import type { PAGE_SIZE } from "utils/common";

export type DMSv3MonitoringFilters = {
  page: number;
  page_size: PAGE_SIZE;
  date_from: Date | null;
  date_to: Date | null;
  dealer_id: number | undefined;
  dms_id: number | undefined;
  severity: DMS_WARNING_SERVERITIES | undefined;
  source: DMS_WARNING_SOURCES | undefined;
  dms_capability_id: DMS_CAPABILITIES | undefined;
};

type DMSv3MonitoringWarningsResponse = {
  items: DMSWarning[];
  nb_pages: number;
  nb_items: number;
};

const component = "DMSv3MonitoringDashboard";

export const DMSv3MonitoringDahsboardQueryKeys = {
  filters: localQueryKey<DMSv3MonitoringFilters>({ component, data: "filters" }),
  warnings: backendQueryKey<DMSv3MonitoringWarningsResponse>({ component, baseUrl: ENV.dmsAccessorBaseURL, endpoint: "/monitoring/warnings/list" })
};
